import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { applyPageMeta } from '../lib/seo';
import { PAGE_META } from '../lib/routeMeta';

export default function NotFoundPage() {
  useEffect(() => {
    applyPageMeta(PAGE_META.notFound);
  }, []);

  return (
    <section className="mx-auto max-w-2xl px-6 py-24 text-center">
      <h1 className="font-display text-4xl uppercase tracking-widest text-brand-redAccent">
        404
      </h1>
      <p className="mt-4 text-lg text-white/80">Page not found.</p>
      <Link
        to="/"
        className="mt-8 inline-block rounded-full bg-brand-red px-6 py-3 font-heading text-sm font-bold uppercase tracking-wider text-white hover:bg-brand-redAccent"
      >
        Back to Home
      </Link>
    </section>
  );
}
